@let isInsideSummary = $isInsideSummary();

<div
  class="x-card x-card_size_m x-white mx-auto"
  [ngClass]="{
    'md:w-1/3 mt-4.5': !isInsideSummary,
    'p-[20px] h-full box-border': isInsideSummary,
  }"
>
  <header class="flex items-center justify-between mb-4">
    <p class="x-font-body-1-bold">
      {{ 'request_form.inspection.inspection_title' | translate }}
    </p>
    <section>
      @if (formGroup.dirty) {
        <button
          appearance="outline"
          tuiButton
          type="button"
          size="s"
          class="x-white complete-button me-2 rounded-[10px]"
          (click)="cancel()"
        >
          {{ 'request_form.inspection.button_cancel' | translate }}
        </button>
        <button
          appearance="primary"
          tuiButton
          type="button"
          size="s"
          class="x-white complete-button rounded-[10px]"
          (click)="submit()"
        >
          {{ 'request_form.inspection.button_submit' | translate }}
        </button>
      }
    </section>
  </header>
  <form [formGroup]="formGroup">
    <tui-radio-list
      size="m"
      [formControlName]="FormFields.InspectionResult"
      [itemContent]="InspectionResultContent"
      [items]="values"
      class="mb-4"
    ></tui-radio-list>
    <ng-template #InspectionResultContent let-data>
      <div class="x-font-body-4-bold mb-4">
        {{ 'request_form.inspection.' + data.name | translate }}
      </div>
    </ng-template>
  </form>
</div>
